<template>
  <div class="idtr-block idtr-section">
    <div class="idtr-band">{{ text.contactTitle }}</div>
    <table class="idtr-table idtr-contact idtr-section__body">
      <colgroup>
        <col class="idtr-col--name" />
        <col class="idtr-col--name" />
      </colgroup>
      <tbody>
        <tr class="idtr-row--head">
          <td class="idtr-cell--head">
            <field-label target="idtr-first-name" class="idtr-cell-fill">{{
              text.firstName
            }}</field-label>
          </td>
          <td class="idtr-cell--head">
            <field-label target="idtr-last-name" class="idtr-cell-fill">{{
              text.lastName
            }}</field-label>
          </td>
        </tr>
        <tr class="idtr-row--value">
          <td>
            <field-input
              id="idtr-first-name"
              v-model="idtrForm.contact.firstName"
              name="First Name"
              rules="required"
            />
          </td>
          <td>
            <field-input
              id="idtr-last-name"
              v-model="idtrForm.contact.lastName"
              name="Last Name"
              rules="required"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <table class="idtr-table idtr-contact idtr-contact--second">
      <colgroup>
        <col class="idtr-col--address" />
        <col class="idtr-col--phone" />
        <col class="idtr-col--email" />
      </colgroup>
      <tbody>
        <tr class="idtr-row--head">
          <td class="idtr-cell--head">
            <field-label target="idtr-address" class="idtr-cell-fill">{{
              text.address
            }}</field-label>
          </td>
          <td class="idtr-cell--head">
            <field-label target="idtr-phone" class="idtr-cell-fill">{{
              text.phone
            }}</field-label>
          </td>
          <td class="idtr-cell--head">
            <field-label target="idtr-email" class="idtr-cell-fill">{{
              text.email
            }}</field-label>
          </td>
        </tr>
        <tr class="idtr-row--address">
          <td>
            <field-label target="idtr-address" class="idtr-cell-fill" />
            <!-- Street (multi-line) / "City , ST 12345" / USA; the separators are fixed text -->
            <div class="idtr-address">
              <ValidationProvider
                rules="required"
                name="Street"
                v-slot="{ errors }"
                mode="lazy"
                tag="span"
                class="idtr-field"
              >
                <field-editable
                  id="idtr-address"
                  v-model="idtrForm.contact.street"
                  :error="errors.length > 0"
                  placeholder="Street"
                />
              </ValidationProvider>
              <div class="idtr-address__line">
                <ValidationProvider
                  rules="required"
                  name="City"
                  v-slot="{ errors }"
                  mode="lazy"
                  tag="span"
                  class="idtr-field"
                >
                  <field-editable
                    v-model="idtrForm.contact.city"
                    :error="errors.length > 0"
                    inline
                    single-line
                    placeholder="City"
                  />
                </ValidationProvider>
                <span class="idtr-address__sep"> , </span>
                <ValidationProvider
                  rules="required|usState"
                  name="State"
                  v-slot="{ errors }"
                  mode="lazy"
                  tag="span"
                  class="idtr-field"
                >
                  <field-editable
                    v-model="idtrForm.contact.state"
                    :error="errors.length > 0"
                    :filter="stateFilter"
                    inline
                    single-line
                    placeholder="ST"
                  />
                </ValidationProvider>
                <!-- interpolated: the template compiler drops a whitespace-only text node -->
                <span class="idtr-address__sep">{{ " " }}</span>
                <ValidationProvider
                  :rules="zipRules"
                  name="ZIP"
                  v-slot="{ errors }"
                  mode="lazy"
                  tag="span"
                  class="idtr-field"
                >
                  <field-editable
                    v-model="idtrForm.contact.zip"
                    :error="errors.length > 0"
                    :filter="zipFilter"
                    inline
                    single-line
                    placeholder="ZIP"
                  />
                </ValidationProvider>
              </div>
              <div>{{ text.country }}</div>
            </div>
          </td>
          <td>
            <field-label target="idtr-phone" class="idtr-cell-fill" />
            <field-input
              id="idtr-phone"
              v-model="idtrForm.contact.phone"
              name="Phone"
              rules="required"
              maska="###-###-####"
            />
          </td>
          <td>
            <field-label target="idtr-email" class="idtr-cell-fill" />
            <field-input
              id="idtr-email"
              v-model="idtrForm.contact.email"
              name="Email"
              rules="required|email"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldInput from "../FieldInput.vue";
import FieldEditable from "../FieldEditable.vue";
import FieldLabel from "../FieldLabel.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldInput, FieldEditable, FieldLabel},
  inject: ["idtrForm"],
  data: () => ({
    text: IDTR_TEXT,
    zipRules: {required: true, regex: /^\d{5}$/},
  }),
  methods: {
    stateFilter: (text) => text.replace(/[^a-z]/gi, "").toUpperCase().slice(0, 2),
    zipFilter: (text) => text.replace(/\D/g, "").slice(0, 5),
  },
};
</script>
